module.exports = __webpack_public_path__ + "fccc19f37176091dd3eee8620e356f91.png";